export default async function ({ app, store, redirect, route, from}) {
  // server guard from bug-157
  if (process.server) return
  if (from && route.path === from.path) {
    if (store.getters["auth/isLoggedIn"]) return
  }

  const isLoginPage =
  /^\/[a-z]{2,4}\/login\/?$/.test(route.path) ||
  /^\/login\/?$/.test(route.path) ||
  route.name?.includes("login") ||
  route.path.includes("/login")

  if (isLoginPage) return

  // cleaned everything up (by: kai 1/19/2026)
  try {
    const user = await store.dispatch("auth/bootstrap", app).catch(() => null)
    if (!user) {
      localStorage.removeItem("clinicId")
      localStorage.removeItem("superadminEmail")
      alert(app.i18n.t("app.login.requiresLogin"))
      return redirect({path: app.localePath("/login"), query: {from: route.fullPath}})
    }
  } catch(e) {
    console.error("[authenticated middleware] bootstrap failed", e)
    alert(app.i18n.t("app.login.requiresLogin"))
    return redirect({path: app.localePath("/login"), query: {from: route.fullPath}})
  }
}